import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { ItemService } from '../services/item.service';
import { IItem } from '../models/IItem';
import { ItemFormComponent } from './item-form/item-form.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-items',
  templateUrl: './items.component.html',
  styleUrls: ['./items.component.scss']
})
export class ItemsComponent implements OnInit, OnDestroy {

  @ViewChild(ItemFormComponent) child: ItemFormComponent;
  items: IItem[];
  filteredItems: IItem[];
  subscription: Subscription;

  constructor(public itemService: ItemService, private routes: ActivatedRoute) { }

  ngOnInit(): void {
    this.subscription = this.itemService.getAll().subscribe(res => {
      this.items = res;
      this.filteredItems = this.items;
    });
  }

  delete(id: string) {
    const result = confirm('You really want to delete this item?').valueOf();
    if (result) { return this.itemService.delete(id); }
  }

  edit(item: IItem) {
    this.child.buildForm(item);
  }

  filter(field: string, value: string) {
    this.filteredItems = this.items.filter(i => i[field].toLowerCase().includes(value.toLowerCase()));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
